import * as types from '../constants/ActionTypes';
import initialState from './initialState';
import _ from 'lodash';

export default function(state = initialState.expediente, action) {
  switch (action.type) {
    case types.SET_EXPEDIENTE:
      return {
        ...state,
        ...action.payload.expediente,
      };

    case types.ADD_ACTUACION: {
      let obj = {
        ...state,
        actuaciones: [...state.actuaciones, action.payload.actuacion],
      };

      // console.log('El objeto me queda...');
      // console.log(obj);
      // console.log('ESTADO: ', state);
      return obj;
    }

    case types.ADD_RECIBO: {
      let obj = {
        ...state,
        recibos: [...state.recibos, action.payload.recibo],
      };

      // console.log('El objeto me queda...');
      // console.log(obj);
      // console.log('ESTADO: ', state);
      return obj;
    }

    case types.UPDATE_ACTUACION: {
      let copiaActuaciones = [...state.actuaciones];
      _.remove(copiaActuaciones, { _id: action.payload.actuacion._id });

      let obj = {
        ...state,
        actuaciones: [...copiaActuaciones, action.payload.actuacion],
      };
      return obj;
    }

    case types.UPDATE_ESTADO_EXPEDIENTE: {
      let obj = {
        ...state,
        estado: action.payload.estado,
      };
      return obj;
    }

    case types.UPDATE_CONTRAVENTOR_EXPEDIENTE: {
      let copiaContraventores = [...state.contraventores];
      _.remove(copiaContraventores, { _id: action.payload.contraventor._id });

      let obj = {
        ...state,
        contraventores: [...copiaContraventores, action.payload.contraventor],
      };
      return obj;
    }

    case types.REINICIAR:
      return initialState.expediente;

    default:
      return state;
  }
}
